<template>
  <div class="guide-detail" draggable="false">
    <div class="error" v-if="error.visible">
      <img v-if="error.type === 'biz'" class="error-image"
        src="https://market-cdn.anoah.com/dm/static/yxp_market_growth_study/common/error_default.png" />
      <img v-if="error.type === 'other'" class="error-image"
        src="https://market-cdn.anoah.com/dm/static/yxp_market_growth_study/common/error_offline.png" />
      <div class="error-text">{{ error.message }}</div>
      <van-button v-if="error.type === 'other'" @click="reload" icon="replay" type="info" size="small" plain round
        style="margin-top:40px">
        重试
      </van-button>
    </div>
    <div style="position:relative" v-else-if="posterUrl">
      <img :src="posterUrl" style="width:100vw" />
      <div class="code-box" :style="codeBoxStyle">
        <img v-if="qrCodeUrl" draggable="false" style="width:100%;height:100%" @touchstart="touchstart"
          @touchend="touchend" :src="qrCodeUrl" @load="loadSuccess" />
        <van-loading v-else size="24px" vertical>加载中...</van-loading>
      </div>
    </div>
    <div v-else class="loading"><van-loading type="spinner" color="#1989fa" style="margin-bottom:20px" />加载中...</div>
  </div>
</template>
<script>
import { getChannelDetail, getGuideInfo } from "@/axios/applyForm/commonForm.js";
const BURIEDPOINT_ACCESSPATH = {
  'WECHAT_APPLET_LINK': 'link',
  'WECHAT_APPLET_H5_LINK': 'h5link',
  'WECHAT_APPLET_QRCODE': 'QRCode'
}
export default {
  data() {
    return {
      channelInfo: {},
      posterUrl: '',
      qrCodeUrl: '',
      url: '',
      error: { visible: false, type: 'biz', message: '业务报错' },
      trackData: {
        pageId: 50030,
        pageName: '推广计划表单推荐导购页'
      },
      codeBoxStyle: {}
    };
  },
  mounted() {
    const { unionId, openId } = this.$route.query;
    yxczxy.setOpenId(openId || '');
    yxczxy.setUnionId(unionId || '');
    this.init();
  },
  beforeDestroy() {
    if (this.showTime) {
      yxczxy.track('PAGE_EXIT', { ...this.trackData, duration: Date.now() - this.showTime });
    }
  },
  methods: {
    reload() {
      location.reload();
    },
    loadSuccess() {
      if (this.qrCodeUrl !== 'https://market-cdn.anoah.com/dm/static/market-h5-smartguide/guide_code_error.png') {
        yxczxy.track('ELEMENT_EXPOSE', this.trackData);
      }
    },
    async init() {
      const { spreadChannelId, spreadPlanId, spreadWay, unionId, openId, longitude, latitude } = this.$route.query;
      try {
        const res = await getChannelDetail({ channelId: spreadChannelId })
        if (res.errcode === 0) {
          if (!res.data) return this.showError('您访问的链接已失效', 'biz');
          this.channelInfo = res.data;
          document.title = res.data.styleConf && res.data.styleConf.title;
          this.posterUrl = res.data.landPageInfo.imageUrl + '?x-oss-process=image/quality,q_95/interlace,1';
          this.renderCodeBox(res.data.landPageInfo);
          this.trackData = {
            ...this.trackData,
            access_path: BURIEDPOINT_ACCESSPATH[spreadWay],
            longitude,
            latitude,
            plan_id: spreadPlanId,
            plan_name: res.data.spreadPlanName,
            channel_id: spreadChannelId,
            channel_name: res.data.name,
          }
          yxczxy.track('PAGE_EXPOSE', this.trackData);
          this.showTime = Date.now();
        } else {
          return this.showError(res.errmsg, 'biz');
        }
      } catch (error) {
        console.log(error);
        return this.showError();
      }
      await this.getRecommendedGuideInfo();

    },
    // 获取导购信息
    async getRecommendedGuideInfo() {
      const { spreadChannelId, spreadPlanId, spreadWay, spreadPlatformCode, latitude, longitude, phone, unionId } = this.$route.query;
      const params = {
        point: {
          longitude: longitude,
          latitude: latitude,
        },
        unionId,
        phone,
        agentId: this.channelInfo.topAgentId,
        data: {
          source: location.href,
          param: [
            { name: 'spreadPlanId', value: spreadPlanId },
            { name: 'spreadChannelId', value: spreadChannelId },
            { name: 'spreadPlatformCode', value: spreadPlatformCode },
            { name: 'spreadWay', value: spreadWay },
          ]
        },
      }
      if (!params.point.longitude || !params.point.latitude) params.point = undefined
      try {
        const res = await getGuideInfo(params);
        if (res.errcode === 0) {
          this.qrCodeUrl = res.data.qrCodeUrl || 'https://market-cdn.anoah.com/dm/static/market-h5-smartguide/guide_code_error.png';
          this.trackData = { ...this.trackData, guideId: res.data.guideId, guideType: res.data.isExclusive ? '专属导购' : '推荐导购' };
        } else {
          return this.showError(res.errmsg, 'biz');
        }
      } catch (error) {
        return this.showError();
      }

    },
    // 计算二维码容器位置
    renderCodeBox({ imageWidth, imageHeight, qrCode }) {
      const windowWidth = window.screen.width;
      const ratio = windowWidth / imageWidth;
      const qrCodeInCanvasLeft = qrCode.left * ratio;
      const qrCodeInCanvasTop = qrCode.top * ratio;
      const qrCodeInCanvasWidth = qrCode.width * ratio;
      const qrCodeInCanvasHeight = qrCode.height * ratio;
      this.codeBoxStyle = {
        width: qrCodeInCanvasWidth + 'px',
        height: qrCodeInCanvasHeight + 'px',
        left: qrCodeInCanvasLeft + 'px',
        top: qrCodeInCanvasTop + 'px'
      }
    },
    showError(message = '哎呀，网络走丢了', type = 'other') {
      this.$set(this.error, 'visible', true);
      this.$set(this.error, 'message', message);
      this.$set(this.error, 'type', type);
    },
    touchstart() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.longPress();
      }, 300);
    },
    touchend() {
      clearTimeout(this.timer);
    },
    // 长按统计
    longPress() {
      yxczxy.track('QR_LONGPRESS', this.trackData);
    },
  },
};
</script>

<style lang="scss" scoped>
#myCanvas {
  position: absolute;
  display: none;
}

.code-box {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-detail {
  width: 100%;
  height: 100%;
}

.error {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.error-btn-entry {
  width: 200px;
  text-align: center;
  margin-top: 40px;
  font-size: 24px;
  color: rgb(138, 138, 138);
}

.error-text {
  font-size: 24px;
  color: rgb(184, 184, 184);
}

.error-image {
  width: 60%;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
